import type { WorkflowApiContract, WorkflowStageApiContract } from '../../../core/api';
import type { WorkflowStageUiModel, WorkflowUiModel } from '../../../core/types';
import { normalizeWorkflowIconKeyForUi } from '../../../shared/utils/workflow-icon-key.util';

function mapWorkflowStageContractToUiModel(stage: WorkflowStageApiContract): WorkflowStageUiModel {
  return {
    id: stage.id,
    name: stage.name,
    order: stage.order,
    colorHex: stage.colorHex,
  };
}

export function mapWorkflowContractToUiModel(contract: WorkflowApiContract): WorkflowUiModel {
  const normalizedDefaultDueInDays =
    typeof contract.defaultDueInDays === 'number' && contract.defaultDueInDays >= 0
      ? contract.defaultDueInDays
      : null;
  return {
    id: contract.id,
    projectId: contract.projectId,
    name: contract.name?.trim() || contract.id || 'Workflow',
    iconKey: normalizeWorkflowIconKeyForUi(contract.iconKey),
    colorHex: contract.colorHex,
    description: contract.description,
    defaultDueInDays: normalizedDefaultDueInDays,
    isAccessRestricted: contract.isAccessRestricted === true,
    stages: contract.stages.map(mapWorkflowStageContractToUiModel),
  };
}
